import * as React from 'react';
import { toast } from '@/hooks/use-toast';
import { ApiError, isSessionExpired, formatApiError } from '@/lib/api';

/** Remember each failure until the next successful read. */
export function usePollErrorToast(title: string) {
  const failures = React.useRef(new Set<string>());
  const reset = React.useCallback(() => { failures.current.clear(); }, []);
  const report = React.useCallback((error: unknown) => {
    if (isSessionExpired() || (error instanceof ApiError && error.status === 401)) return;
    const message = formatApiError(error, 'Request failed');
    if (failures.current.has(message)) return;
    failures.current.add(message);
    toast({ title, description: message, variant: 'destructive' });
  }, [title]);
  return { report, reset };
}
